(function () {
  var timer;

  function getSizeSelect() {
    return document.querySelector('select[name^="options[Size]"]') ||
      document.querySelector('select[name*="[Size]"]') ||
      document.querySelector('select[data-option-position="2"]');
  }

  function getSizeState() {
    var select = getSizeSelect();
    if (!select || !select.value) return 'blank';
    var option = select.options[select.selectedIndex];
    return option && /unavailable|sold out/i.test(option.textContent) ? 'unavailable' : 'available';
  }

  function syncAvailability() {
    var state = getSizeState();
    document.querySelectorAll('.price').forEach(function (price) {
      price.classList.toggle('price--sold-out', state === 'unavailable');
    });
    document.querySelectorAll('.price__badge, .price__badge-sold-out, .price__badge-sold_out').forEach(function (badge) {
      var show = state === 'unavailable';
      badge.hidden = !show;
      if (show) badge.removeAttribute('aria-hidden');
      else badge.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('button[name="add"], .product-form__submit').forEach(function (button) {
      var label = state === 'blank' ? 'Select a Size' : state === 'unavailable' ? 'Sold out' : 'Add to cart';
      button.disabled = state !== 'available';
      button.classList.toggle('disabled', state !== 'available');
      var buttonText = button.querySelector('span');
      if (buttonText && buttonText.textContent.trim() !== label) buttonText.textContent = label;
    });
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(syncAvailability, 40);
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncAvailability();
    new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true});
  });
  document.addEventListener('change', schedule);
  window.addEventListener('load', syncAvailability);
  syncAvailability();
})();